module.exports = __webpack_public_path__ + "img/fibres_illustration_card.0736257.jpg";